module.exports = __webpack_public_path__ + "static/media/ashmayu.0f3da740.jpeg";